import React from 'react'
import { FormInner, FormContainer, Form, FormHeading, FieldsWrapper, FieldDiv, SubmitWrapper } from '../styled-elements'
import FormLabel from '@mui/material/FormLabel'
import Autocomplete from '@mui/material/Autocomplete'
import Checkbox from '@mui/material/Checkbox'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import FormControlLabel from '@mui/material/FormControlLabel'
import { makeStyles } from '@material-ui/core/styles'
import { RoundedFormButton } from '../../../styles/styled-elements'

const FormElement = ({
                       siteOptions,
                       formInputChangeHandler,
                       setSelectedValue,
                       toggleMapValue,
                       handleSubmit,
                       state
                     }) => {

  const useStyles = makeStyles((theme) => {
    return ({
      textFieldInput: {
        fontSize: 13,
        height: '1.4em',
      },
      textFieldInputLabel: {
        fontSize: '13px !important'
      }
    })
  })

  const classes = useStyles();
  const socialMediaList = ["Facebook", "Instagram", "Twitter", "LinkedIn", "TikTok", "Other"];
  const formData = state.formData;

  return <FormContainer>
    <FormInner>
      <Form onSubmit={handleSubmit}>
        {state.formErrors &&
          <FormHelperText style={{ textAlign: 'center', fontSize: '1.2em' }} error>{state.formErrors}</FormHelperText>
        }
        <FieldsWrapper show={(!formData.addressSameAsPrimary)}>
          <FieldDiv>
            <Autocomplete
              required
              name="user1Age"
              options={[
                'Under 18',
                '18-25',
                '26-35',
                '36-45',
                '46-55',
                '56-65',
                'Over 65',
              ]}
              onChange={(event, newValue) => {
                setSelectedValue('user1Age', newValue)
              }}
              value={formData.user1Age}
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  variant="standard"
                  label="Primary User's Age"
                  InputProps={{ ...params.InputProps, className: classes.textFieldInput }}
                  InputLabelProps={{ ...params.InputLabelProps, className: classes.textFieldInputLabel }}
                />
              )}
              style={{ marginTop: 20, width: 200 }}
            />
            <FormHelperText error>{state.errors && state.errors.user1Age}</FormHelperText>
          </FieldDiv>
          <FieldDiv>
            <Autocomplete
              required
              name="user1Gender"
              options={[
                'Male',
                'Female',
                'Unspecified',
              ]}
              onChange={(event, newValue) => {
                setSelectedValue('user1Gender', newValue)
              }}
              value={formData.user1Gender}
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  variant="standard"
                  label="Primary User's Gender"
                  InputProps={{ ...params.InputProps, className: classes.textFieldInput }}
                  InputLabelProps={{ ...params.InputLabelProps, className: classes.textFieldInputLabel }}
                />
              )}
              style={{ marginTop: 20, width: 200 }}
            />
            <FormHelperText error>{state.errors && state.errors.user1Gender}</FormHelperText>
          </FieldDiv>
          <FieldDiv>
            <TextField
              required
              multiline
              variant="standard"
              label="Occupation/Industry"
              name="occupationIndustry"
              inputProps={{
                autoCorrect: 'off',
                autoCapitalize: 'words',
                autoComplete: 'occupationIndustry',
                maxLength: 50,
              }}
              value={formData.occupationIndustry || ''}
              onChange={formInputChangeHandler}
              error={state.errors && state.errors.occupationIndustry}
              style={{ width: '100%', marginTop: 20 }}
              InputProps={{ className: classes.textFieldInput }}
              InputLabelProps={{ className: classes.textFieldInputLabel }}
            />
            <FormHelperText error>{state.errors && state.errors.occupationIndustry}</FormHelperText>
          </FieldDiv>
          <FieldDiv>
            <Autocomplete
              id="selected-aws-autocomplete-input"
              name="mainAwsOfInterest"
              options={siteOptions}
              onChange={(event, newValue) => {
                setSelectedValue('mainAwsOfInterest', newValue)
              }}
              value={formData.mainAwsOfInterest}
              isOptionEqualToValue={(a, b) => {
                return (a.value === b.value)
              }}
              renderInput={(params) => (
                <TextField
                  required
                  {...params}
                  label="Main Mesonet Station of Interest"
                  variant="standard"
                  placeholder="Type to search"
                  InputProps={{ ...params.InputProps, className: classes.textFieldInput }}
                  InputLabelProps={{ ...params.InputLabelProps, className: classes.textFieldInputLabel }}
                />
              )}
              style={{ marginTop: 20, width: 300 }}
            />
            <FormHelperText error>{state.errors && state.errors.mainAwsOfInterest}</FormHelperText>
          </FieldDiv>
          <FieldDiv>
            <TextField
              required
              multiline
              variant="standard"
              label="Main Use of Mesonet"
              name="mainUseOfMesonet"
              inputProps={{
                autoCorrect: 'off',
                autoCapitalize: 'words',
                autoComplete: 'mainUseOfMesonet',
                maxLength: 500,
              }}
              value={formData.mainUseOfMesonet || ''}
              onChange={formInputChangeHandler}
              error={state.errors && state.errors.mainUseOfMesonet}
              style={{ width: '100%', marginTop: 20 }}
              InputProps={{ className: classes.textFieldInput }}
              InputLabelProps={{ className: classes.textFieldInputLabel }}
            />
            <FormHelperText error>{state.errors && state.errors.mainUseOfMesonet}</FormHelperText>
          </FieldDiv>
          <FieldDiv>
            <Autocomplete
              required
              name="farmSize"
              options={[
                'Under 100 ha',
                '100-200 ha',
                '200-400 ha',
                '400-600 ha',
                '600-800 ha',
                '800-1000 ha',
                '1000-1500 ha',
                '1500-2000 ha',
                'Over 2000 ha',
                'N/A',
              ]}
              onChange={(event, newValue) => {
                setSelectedValue('farmSize', newValue)
              }}
              value={formData.farmSize}
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  variant="standard"
                  label="Approximate farm size"
                  InputProps={{ ...params.InputProps, className: classes.textFieldInput }}
                  InputLabelProps={{ ...params.InputLabelProps, className: classes.textFieldInputLabel }}
                />
              )}
              style={{ marginTop: 20, width: 200 }}
            />
            <FormHelperText error>{state.errors && state.errors.farmSize}</FormHelperText>
          </FieldDiv>
          <FieldDiv>
            <TextField
              variant="standard"
              label="Main crop type"
              name="mainCropType"
              inputProps={{
                autoCorrect: 'off',
                autoCapitalize: 'words',
                autoComplete: 'mainCropType',
                maxLength: 50,
              }}
              value={formData.mainCropType || ''}
              onChange={formInputChangeHandler}
              error={state.errors && state.errors.mainCropType}
              style={{ width: '100%', marginTop: 20 }}
              InputProps={{ className: classes.textFieldInput }}
              InputLabelProps={{ className: classes.textFieldInputLabel }}
            />
            <FormHelperText error>{state.errors && state.errors.mainCropType}</FormHelperText>
          </FieldDiv>
          <FieldDiv>
            <TextField
              variant="standard"
              label="Main Two Herbicides Used in Summer"
              name="mainTwoHerbicidesUsedInSummer"
              inputProps={{
                autoCorrect: 'off',
                autoCapitalize: 'words',
                autoComplete: 'mainTwoHerbicidesUsedInSummer',
                maxLength: 50,
              }}
              value={formData.mainTwoHerbicidesUsedInSummer || ''}
              onChange={formInputChangeHandler}
              error={state.errors && state.errors.mainTwoHerbicidesUsedInSummer}
              style={{ width: '100%', marginTop: 20 }}
              InputProps={{ className: classes.textFieldInput }}
              InputLabelProps={{ className: classes.textFieldInputLabel }}
            />
            <FormHelperText error>{state.errors && state.errors.mainTwoHerbicidesUsedInSummer}</FormHelperText>
          </FieldDiv>
          <FieldDiv>
            <TextField
              variant="standard"
              label="Usual supplier of summer herbicide"
              name="usualSupplierOfSummerHerbicide"
              inputProps={{
                autoCorrect: 'off',
                autoCapitalize: 'off',
                autoComplete: 'usualSupplierOfSummerHerbicide',
                maxLength: 50,
              }}
              value={formData.usualSupplierOfSummerHerbicide || ''}
              onChange={formInputChangeHandler}
              error={state.errors && state.errors.usualSupplierOfSummerHerbicide}
              style={{ width: '100%', marginTop: 20 }}
              InputProps={{ className: classes.textFieldInput }}
              InputLabelProps={{ className: classes.textFieldInputLabel }}
            />
            <FormHelperText error>{state.errors && state.errors.usualSupplierOfSummerHerbicide}</FormHelperText>
          </FieldDiv>
          <FieldDiv>
            <Autocomplete
              required
              name="whereHeardAboutUs"
              options={[
                'Word of Mouth',
                'Recommendation from trusted advisor / agronomist',
                'Social Media',
                'Google search',
                'Event/expo/conference',
                'General media',
                'Ads',
                'Other',
              ]}
              onChange={(event, newValue) => {
                setSelectedValue('whereHeardAboutUs', newValue)
              }}
              value={formData.whereHeardAboutUs}
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  variant="standard"
                  label="Where did you hear about us?"
                  InputProps={{ ...params.InputProps, className: classes.textFieldInput }}
                  InputLabelProps={{ ...params.InputLabelProps, className: classes.textFieldInputLabel }}
                />
              )}
              style={{ marginTop: 20, width: 400 }}
            />
            <FormHelperText error>{state.errors && state.errors.whereHeardAboutUs}</FormHelperText>
          </FieldDiv>
          <FieldDiv>
            <p>Do you use social media (click all that apply)?</p>
            {socialMediaList.map((socialMediaValue) => {
              return <FormControlLabel
                key={socialMediaValue}
                control={<Checkbox
                  checked={formData.socialMediaUse.has(socialMediaValue)}
                  name="socialMediaUse"
                  onChange={(event, newValue) => {
                    toggleMapValue(formData.socialMediaUse, socialMediaValue);
                  }}
                  value={socialMediaValue}
                />}
                label={socialMediaValue}/>
            })}
          </FieldDiv>
        </FieldsWrapper>
        <SubmitWrapper>
          <RoundedFormButton enabled={(state.canSubmit)}>Update</RoundedFormButton>
        </SubmitWrapper>
      </Form>
    </FormInner>
  </FormContainer>
}

export default class UserSurveyForm extends React.Component {

  constructor(props) {
    super(props)
    this.state = this.propsToInitialState(props);
  }

  componentDidUpdate(prevProps, prevState) {
    const { props, state } = this
    const { formData, origValues } = state
    const newState = {}

    // 2. Check if required fields are filled
    const requiredFields = [
      'user1Age',
      'user1Gender',
      'occupationIndustry',
      'mainAwsOfInterest',
      'mainUseOfMesonet',
      'whereHeardAboutUs'
    ]
    const canSubmit = requiredFields.every((key) => formData[key])
    if (canSubmit !== state.canSubmit) {
      newState.canSubmit = canSubmit
    }

    if (Object.keys(newState).length > 0) {
      this.setState(newState)
    }
  }

  propsToInitialState(props) {
    return {
      formData: {
        user1Age: props.user1Age || '',
        user1Gender: props.user1Gender || '',
        occupationIndustry: props.occupationIndustry || '',
        mainAwsOfInterest: props.mainAwsOfInterest || '',
        mainUseOfMesonet: props.mainUseOfMesonet || '',
        farmSize: props.farmSize || '',
        mainCropType: props.mainCropType || '',
        mainTwoHerbicidesUsedInSummer: props.mainTwoHerbicidesUsedInSummer || '',
        usualSupplierOfSummerHerbicide: props.usualSupplierOfSummerHerbicide || '',
        whereHeardAboutUs: props.whereHeardAboutUs || '',
        socialMediaUse: props.socialMediaUse || new Map(),
      },
      canSubmit: false,
      hasErrors: false,
      formErrors: null,
      errors: null,
    }
  }

  formInputChangeHandler = (e) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.value,
      },
      hasChanged: true,
    })
  }

  setSelectedValue = (stateItem, v) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [stateItem]: v ? v : '',
      },
      hasChanged: true,
    })
  }

  toggleMapValue = (map, value) => {
    if (map.has(value)) {
      map.delete(value);
    } else {
      map.set(value, true);
    }
    console.log(map);
    this.setState({ hasChanged: true });
  }

  validate = (callback) => {
    const errors = {}
    const {
      user1Age,
      user1Gender,
      occupationIndustry,
      mainAwsOfInterest,
      mainUseOfMesonet,
      farmSize,
      mainCropType,
      mainTwoHerbicidesUsedInSummer,
      usualSupplierOfSummerHerbicide
    } = this.state
    if (Object.keys(errors).length) {
      this.setState({
        hasErrors: true,
        errors: errors
      })
    } else {
      callback.call(this)
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()

    // Reset errors
    this.setState({
      hasErrors: false,
      formErrors: null,
      errors: null,
    })

    // Extract formData from state
    const { formData } = this.state

    // Call validate and submit handler
    this.validate(() => {
      this.props.submitHandler.call(this, formData)
    })
  }

  updateLoading = (value) => {
    this.setState({ loading: !!value })
  }

  renderBody = () => {
    const { formData } = this.state;
    const {
      user1Age, user1Gender, occupationIndustry, mainAwsOfInterest, mainUseOfMesonet, farmSize, mainCropType,
      mainTwoHerbicidesUsedInSummer, usualSupplierOfSummerHerbicide, whereHeardAboutUs, socialMediaUse
    } = formData;

    return (
      <FormElement
        user1Age={user1Age}
        user1Gender={user1Gender}
        occupationIndustry={occupationIndustry}
        mainAwsOfInterest={mainAwsOfInterest}
        mainUseOfMesonet={mainUseOfMesonet}
        farmSize={farmSize}
        mainCropType={mainCropType}
        mainTwoHerbicidesUsedInSummer={mainTwoHerbicidesUsedInSummer}
        usualSupplierOfSummerHerbicide={usualSupplierOfSummerHerbicide}
        whereHeardAboutUs={whereHeardAboutUs}
        socialMediaUse={socialMediaUse}
        siteOptions={this.props.siteOptions}
        formInputChangeHandler={this.formInputChangeHandler}
        setSelectedValue={this.setSelectedValue}
        toggleMapValue={this.toggleMapValue}
        handleSubmit={this.handleSubmit}
        state={this.state}
      />
    );
  }

  render() {
    return this.renderBody();
  }
}
